import React, { Fragment, useEffect } from 'react'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { useApi } from '../../../hooks/useApi'
import { ApiConfig } from '../../../config/api'
import axios from 'axios'
import { Status } from '../../../hooks/useFetchState'
import { Loading } from '../../UI'
import { formatCurrency } from '../../../utils/parsers'

interface AsnDetailsProps {
  asnId: number
  hideInfoReturnAsn?: boolean
}

interface AsnDetailSummaryDto {
  asnId: number
  lpns: string
  totalSkus: number
  hasExpirationDate: boolean
  hasPrioritizedSku: boolean
  totalCost: number
  hasFefo: boolean
}

const getAsnDetailSummary = (asnId: number) => {
  const url = new URL(`${ApiConfig.AsnApi}/${asnId}/summary`)

  return axios.get(url.toString())
}

export const AsnDetails: React.FC<AsnDetailsProps> = ({
  asnId,
  hideInfoReturnAsn
}) => {
  const { callApi, state } = useApi<AsnDetailSummaryDto>()

  const requestAsnDetailSummary = () => {
    callApi(getAsnDetailSummary(asnId)).catch((error) => console.log(error))
  }

  useEffect(() => {
    requestAsnDetailSummary()
  }, [asnId])

  if (state.status === Status.Loading) {
    return <Loading />
  }

  return (
    <Fragment>
      <Grid container xs={12} spacing={1} style={{ paddingLeft: '20px' }}>
        {state.error !== undefined && (
          <Fragment>
            <Grid item xs={12} sm={12} md={4} lg={8}>
              <b>{state.error}</b>
            </Grid>
          </Fragment>
        )}
        {state.error === undefined && (
          <Fragment>
            <Grid item xs={12}>
              <Typography variant='body2' component='p'>
                <b>LPN: </b>
                {state.data?.lpns}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant='body2' component='p'>
                <b>SKU totales: </b>
                {state.data?.totalSkus}
              </Typography>
            </Grid>
            {!hideInfoReturnAsn && (
              <Fragment>
                <Grid item xs={12}>
                  <Typography variant='body2' component='p'>
                    <b>¿Trae fecha de caducidad?: </b>
                    {state.data?.hasFefo ? 'SI' : 'NO'}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant='body2' component='p'>
                    <b>¿Contiene SKU priorizado?: </b>
                    {state.data?.hasPrioritizedSku ? 'SI' : 'NO'}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant='body2' component='p'>
                    <b>Costo total de la ASN: </b>
                    {formatCurrency(state.data?.totalCost || 0, 'CLP')}
                  </Typography>
                </Grid>
              </Fragment>
            )}
          </Fragment>
        )}
      </Grid>
    </Fragment>
  )
}
